import React from "react"

import {AutoComplete, ResultProps} from "@components/elements"
import {Option} from "@components/form"
import {gameApiCalls} from "../service"


type GameSearchProps = {
    onSelect: (value: Option) => any
}

export function GameSearch({onSelect}: GameSearchProps) {

    async function onSearch(val: string): Promise<ResultProps[]> {
        const games = await gameApiCalls
            .apiCalls
            .list({searchText: val})

        return games.map(game => {

            return {
                element: <div className="flex">
                    <div className="ml-3 flex flex-col">
                        <span className="text-sm font-medium">{game.info.title}</span>
                    </div>
                </div>,
                label: game.info.title,
                value: game._id.toString(),
                data: game
            }
        })
    }


    return <AutoComplete
        placeholder="Search by game title"
        onSearch={onSearch}
        onSelect={onSelect}
    />
}